<template lang="pug">
    v-layout(justify-center align-center)
      v-btn(dark, flat, @click="clickHandler" class="mr-3 py-2", outline) {{$t('KuratorsPage.FilterWindow.btnFilter')}}
        v-icon(color="white") arrow_drop_down
      v-slide-y-transition
        v-card(class="search-card pb-4 pt-2 px-2 elevation-4" v-if="expand")
          v-layout(column justify-center)
            v-flex(xs12 v-if="!isReportFilters")
              v-text-field(
                v-model.trim="inn",
                prepend-icon="perm_contact_calendar"
                autofocus,
                hide-details,
                :placeholder="$t('KuratorsPage.FilterWindow.writeInn')",
                mask="##############",
                class="mb-1")
            v-flex(xs12 v-if="!isReportFilters")
              v-text-field(
                v-model.trim="okpo",
                prepend-icon="event_note"
                autofocus,
                hide-details,
                :placeholder="$t('KuratorsPage.FilterWindow.writeOkpo')",
                mask="########",
                class="mb-1")
            v-flex(xs12 v-if="isReportFilters")
              v-select(
                :items="reportList",
                v-model="select",
                item-text="reportName",
                item-value="reportKey",
                :no-data-text="$t('common.noDateReport')",
                prepend-icon="event_note"
                hide-details,
                :placeholder="$t('KuratorsPage.FilterWindow.formReporting')",
                class="mb-1")
            v-flex(xs12, v-if="isArchiveFilters || isReportFilters")
              template(v-if="isArchiveFilters")
                v-select(
                :items="reportList",
                v-model="select",
                item-text="reportName",
                item-value="reportKey",
                :no-data-text="$t('common.noDateReport')",
                prepend-icon="event_note"
                hide-details,
                :placeholder="$t('KuratorsPage.FilterWindow.formReporting')",
                class="mb-1")
              v-menu(
                ref="menu"
                v-model="menu1",
                lazy,
                transition="scale-transition",
                :close-on-content-click="false",
                offset-y,
                full-width,
                max-width="290")
                template(v-slot:activator="{ on }")
                  v-text-field(
                    slot="activator",
                    prepend-icon="event",
                    hide-details,
                    readonly,
                    v-on="on",
                    v-model="startDate",
                    :placeholder="$t('KuratorsPage.FilterWindow.periodBefore')",
                    class="mb-1")
                v-date-picker(
                  no-title,
                  ref="picker",
                  locale="ru",
                  v-model="startDate",
                  @input="menu1 = false")
            v-flex(xs12, v-if="isArchiveFilters || isReportFilters")
              v-menu(
                ref="menu",
                v-model="menu2",
                lazy,
                transition="scale-transition",
                :close-on-content-click="false",
                offset-y,
                full-width,
                max-width="290")
                template(v-slot:activator="{ on }")
                  v-text-field(
                    slot="activator",
                    prepend-icon="event",
                    hide-details,
                    readonly,
                    v-on="on",
                    v-model="expirationDate",
                    :placeholder="$t('KuratorsPage.FilterWindow.periodAfter')")
                v-date-picker(
                  no-title,
                  ref="picker",
                  locale="ru",
                  v-model="expirationDate",
                  @input="menu2 = false")
            v-layout(justify-center class="mt-4 text-xs-center")
              v-flex(xs12)
                v-btn(
                  color="secondary",
                  class="filter-btn",
                  @click="filterHandler") {{$t('KuratorsPage.FilterWindow.btnVisible')}}
</template>

<script>
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { actionTypes as archiveActionTypes, mutationTypes as archiveMutationTypes } from '@/store/modules/archive/types'

@Component({})
export default class Search extends Vue {
  expand = false
  inn = null
  okpo = null
  startDate = null
  expirationDate = null
  select = null
  menu1 = false
  menu2 = false
  isRespondentsFilters = false
  isArchiveFilters = false
  isReportFilters = false

  @Watch('formName') onChanged(val) {
    this.expand = false
    this.isRespondentsFilters = val === 'respondents'
    this.isReportFilters = val === 'reports'
    this.isArchiveFilters = val === 'archive'
  }

  mounted() {
    this.$store.dispatch('GET_REPORT_LIST')
  }

  get formName() {
    return this.$route.meta.form
  }

  get reportList() {
    return this.$store.getters.getReportList
  }

  get checkFormFields() {
    return this.inn || this.okpo
  }

  get checkDataPeriodFields() {
    return this.startDate && this.expirationDate
  }

  clickHandler() {
    this.expand = !this.expand
    switch (this.$router.history.current.name) {
      case 'respondents':
        this.isRespondentsFilters = true
        break
      case 'curator-archive':
        this.isArchiveFilters = true
        break
      case 'curator-reports':
        this.isReportFilters = true
        break
    }
  }

  showNotification(text) {
    this.$store.dispatch('NOTIFICATION', {
      open: true,
      color: 'red',
      text
    })
  }

  respondentsFilterRequest() {
    if (!this.checkFormFields) {
      this.showNotification('Вы не заполнили все необходимые поля для поиска респондентов')
      return
    }
    this.$store.dispatch('GET_RESPONDENTS', {
      inn: this.inn,
      okpo: this.okpo
    })
  }

  archivesFilterRequest() {
    if (!this.checkDataPeriodFields) {
      this.showNotification('Вы не заполнили обязательные поля "Период с:" и "Период по:" для поиска данных в архиве')
      return
    }

    const payload = {
      inn: this.inn,
      okpo: this.okpo,
      startDate: this.startDate,
      expirationDate: this.expirationDate,
      reportType: this.select
    }

    this.$store.commit(archiveMutationTypes.setPageIndex, 0)
    this.$store.commit(archiveMutationTypes.setPageSize, 10000)
    this.$store.dispatch(archiveActionTypes.getRespondentReports, payload)
  }

  reportsFilterRequest() {
    if (!this.select) {
      this.showNotification('Вы не заполнили все необходимые поля для поиска данных статистики')
    } else {
      this.$store.dispatch('GET_STATISTIC', {
        reportKey: this.select,
        startDate: this.startDate,
        expirationDate: this.expirationDate
      })
    }
  }

  filterHandler() {
    try {
      if (this.isArchiveFilters) this.archivesFilterRequest()
      if (this.isRespondentsFilters) this.respondentsFilterRequest()
      if (this.isReportFilters) this.reportsFilterRequest()
      this.$store.commit('SET_VISIBLE_REFRESH_BTN', true)
      this.expand = false
      this.clearItem()
    } catch (e) {
      this.expand = false
    }
  }

  clearItem() {
    this.inn = null
    this.okpo = null
    this.startDate = null
    this.expirationDate = null
    this.select = null
  }
}
</script>

<style lang="scss" scoped>
.search-card {
  position: absolute;
  top: 52px;
  right: 231px;
  max-width: 240px;
  width: 100%;
}
.filter-btn {
  border-radius: 2px;
  padding: 6px 8px;
}
.v-card {
  .v-btn {
    width: 145px;
    height: 36px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    text-transform: capitalize;
    border-radius: 7px;
    padding: 8px 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage/common/Search.vue